import RootApp from './RootApp';
import React from 'react';
import ReactDOM from "react-dom/client";

// let user = localStorage.getItem("user");
// user = JSON.parse(user);

ReactDOM.createRoot(document.getElementById("root")).render(
    <RootApp />
);
